import { useLayoutEffect, useState} from 'react'


interface AbsolutePosition {
    readonly width: number;
    readonly height: number;
    readonly top: number;
    readonly left: number;
    readonly right: number;
    readonly bottom: number;
    // readonly containerWidth: number;
    // readonly containerHeight: number;
    // readonly right: number;
    // readonly width: number;
    // readonly x: number;
    // readonly y: number;
}

function getScrollParent(node: HTMLElement | null): HTMLElement {
    while (node && node !== document.body) {
        const overflowY = window.getComputedStyle(node).overflowY;
        if (overflowY === 'scroll' || overflowY === 'auto') {
            return node;
        }
        node = node.parentElement;
    }
    return document.documentElement;
}

// https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
function findContainingBlock(element: HTMLElement|null): HTMLElement {
    let current: HTMLElement | null = element;

    while(current && current !== document.body) {
        const computedStyle = window.getComputedStyle(current);
        const position = computedStyle.position;

        // If the position is not static, this is the containing block
        if (position !== 'static') {
            return current;
        }

        current = current.parentElement;
    }

    // If no containing block is found, return null (e.g., the root document)
    return document.body;
}

// interface SimpleRect {
//     readonly width: number;
//     readonly height: number;
//     readonly top: number;
//     readonly left: number;
// }
//
// class ComputedRect implements SimpleRect {
//     width: number
//     height: number
//     top: number
//     left: number
//     constructor(rect: SimpleRect) {
//         this.width = rect.width;
//         this.height = rect.height;
//     }
//
// }

export function useAbsolutePosition(element: HTMLElement | null) {
    const [pos, setPos] = useState<AbsolutePosition | null>(null)

    // const container = useMemo(() => findContainingBlock(element), [element])
    const container = element?.offsetParent ?? document.body

    useLayoutEffect(() => {
        if(!element) return

        const updateRect = () => {
            const newRect = element.getBoundingClientRect()
            const containerRect = container.getBoundingClientRect()

            // console.log(offsetRect)

            setPos(prevPos => {
                const newPos = {
                    top: newRect.top - containerRect.top,
                    bottom: newRect.top - containerRect.top + newRect.height,
                    left: newRect.left - containerRect.left,
                    right: newRect.left - containerRect.left + newRect.width,
                    width: newRect.width,
                    height: newRect.height,
                    // containerWidth: containerRect.width,
                    // containerHeight: containerRect.height,
                }


                if(prevPos == null) return newPos

                if(newPos.left === prevPos.left
                    && newPos.top === prevPos.top
                    && newPos.width === prevPos.width
                    && newPos.height === prevPos.height
                    // && newPos.containerWidth === prevPos.containerWidth
                    // && newPos.containerHeight === prevPos.containerHeight
                ) {
                    return prevPos
                }

                return newPos
            })
        }

        updateRect()

        const observer = new ResizeObserver(updateRect)
        observer.observe(element)
        observer.observe(container)

        return () => observer.disconnect()
    }, [container, element])

    return [pos,container] as const
}

